var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubspot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6385 12.6659C11.736 12.6659 11.0044 11.9418 11.0044 11.0488C11.0044 10.1556 11.736 9.43161 12.6385 9.43161C13.5411 9.43161 14.2727 10.1556 14.2727 11.0488C14.2727 11.9418 13.5411 12.6659 12.6385 12.6659ZM13.1278 7.93543V6.49682C13.5072 6.31946 13.773 5.93959 13.773 5.49875V5.46554C13.773 4.8571 13.27 4.35931 12.6552 4.35931H12.6218C12.007 4.35931 11.5039 4.8571 11.5039 5.46554V5.49875C11.5039 5.93959 11.7697 6.31961 12.1492 6.49697V7.93543C11.5842 8.02186 11.068 8.25245 10.6423 8.59181L6.65091 5.51923C6.67726 5.41914 6.69576 5.31611 6.69592 5.2078C6.69654 4.51883 6.133 3.95943 5.43648 3.9585C4.74028 3.95772 4.17486 4.51557 4.17407 5.20469C4.17329 5.89382 4.73683 6.45322 5.43335 6.45399C5.66024 6.4543 5.87036 6.39053 6.05444 6.28687L9.9806 9.30949C9.64677 9.80821 9.45108 10.4056 9.45108 11.0488C9.45108 11.7221 9.66606 12.345 10.0292 12.8572L8.83532 14.0389C8.74093 14.0108 8.64308 13.9912 8.53928 13.9912C7.96711 13.9912 7.50313 14.4502 7.50313 15.0164C7.50313 15.5828 7.96711 16.0418 8.53928 16.0418C9.11161 16.0418 9.57543 15.5828 9.57543 15.0164C9.57543 14.914 9.55567 14.817 9.52729 14.7236L10.7083 13.5549C11.2444 13.9597 11.9121 14.203 12.6385 14.203C14.399 14.203 15.8259 12.7908 15.8259 11.0488C15.8259 9.4718 14.6552 8.16896 13.1278 7.93543Z",
    fill: "#FF7A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspot);
export default __webpack_public_path__ + "static/media/hubspot.0f293ae3cfc01c7bca007b8a7e6ce289.svg";
export { ForwardRef as ReactComponent };